/*
 * @Author: Vanny
 * @Date: 2019-12-09 09:28:43
 * @LastEditors: Vanny
 * @LastEditTime: 2020-06-12 14:58:13
 * @Description:
 */
import axios from 'axios';
import qs from 'querystring';
import invariant from 'invariant';

import { isProdTest } from '../utils';
import { isMC } from '../utils/env';

const baseUrl =
  process.env.APP_TYPE === 'mc'
    ? 'https://translate2.dokkr.net/index.php/api/get_language_file'
    : 'https://translate.duoke.net/index.php/api/get_language_file';
// 获取属性信息(attr_alias, attr_map)
export function getUserAttr(params) {
  invariant(params?.type, '缺少 type');
  return axios.post('/user/get_attr', params);
}

// 个人一些数据
export function getCommissionAttrById(params = { id: 'all' }) {
  return axios.get(`/data/get_commission_attr_by_id/${params.id}`);
}
//  staff信息
export function getStaff(params) {
  // return axios.post('/user/get_staff', params);
  return axios.get('user/self_staff_info');
}
export function getConfigs(){
  return axios.get('user/get_configs');
}
// 得到用户color
export function getUserColor() {
  return axios.post('/user/get_color');
}

// 多客启动初始化函数
export function getStartUp() {
  return axios.get('/user/startup?request_app_agent=web');
}

export function updateImage(params) {
  invariant(params.url, '缺少Url');
  invariant(params.data, '缺少Data');
  return axios.post(params.url, params.data);
}

// 国家列表
export function getCountryInfo(lang) {
  return axios.get(baseUrl, {
    params: { utime: 0, project: JSON.stringify([5]), type: 'production', lang },
  });
}

// 获取语言包
export function requestLangFile(params) {
  return axios.get(`${baseUrl}?${qs.stringify(params)}`);
}

// 获取导入语言包
export function requestImportFile(params) {
  return axios.get('/report/get_template_header', {
    params: {
      langs: isMC() ? '["chs","cht","de","en","es","fr","it","tr","pt"]' : '["chs"]',
      template_id: `[${'12345'.split('')}]`,
      ...params,
    },
  });
  // return axios.post('/report/get_template_header', {
  //   lang: isMC() ? ['chs', 'cht', 'de', 'en', 'es', 'fr', 'it'] : ['chs'],
  //   template_id: '12345'.split(''),
  //   ...params,
  // });
}
// 获取报表列表(我的报表)
export function requestReports() {
  return axios.get(`/api/bi/staff/reports?${qs.stringify({ page: 1, per_page: 50 })}`, {
    axiosConfig: { key: 'databox', env: isProdTest() ? 'test' : '' },
  });
}

// Air - 获取数据跟踪器详情
export function requestTraceBox(params) {
  invariant(params.key, 'miss the key');

  return axios.post(
    '/api/data/get',
    { keys: JSON.stringify([params.key]) },
    { axiosConfig: { key: 'databox', hasKey: 1, env: isProdTest() ? 'test' : '' } }
  );
}
// Air - 设置数据跟踪器详情
export function requestUpdateTraceBox(params) {
  invariant(params.key, 'miss the key');
  invariant(params.value, 'miss the value');
  invariant(params.value.title, 'miss the title');

  return axios.post(
    '/api/data/save',
    { data: JSON.stringify({ [params.key]: params.value }) },
    { axiosConfig: { key: 'databox', hasKey: 1, env: isProdTest() ? 'test' : '' } }
  );
}
